import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

const useStyles = createUseStyles((theme) => ({
    content: {
        '& li': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            marginLeft: theme.spacing[8]
        },
        fontSize: theme.fontSize.md,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey00,
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg':
                case 'md': return {
                    paddingLeft: theme.spacing[16]
                };
                default: return {
                    paddingLeft: '0.4rem'
                };
            }
        }
    }
}));

const HtmlCell = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { htmlText } = props;

    if (!htmlText) {
        return null;
    }

    let specialConditionsWrapped = htmlText;
    if (!specialConditionsWrapped.includes('</')) {
        specialConditionsWrapped = `<ul><li>${specialConditionsWrapped}</li></ul>`;
    }

    return (
        <div
            dangerouslySetInnerHTML={{ __html: specialConditionsWrapped }}
            className={classNames(classes.content)}
        />
    );
};

HtmlCell.propTypes = {
    htmlText: PropTypes.string
};

export { HtmlCell };
